import { useMemo } from 'react';

import { useTranslations } from '@core/js/hooks/i18n';

import { useDynamicTagList } from '@interlayer/js/app/hooks/useDynamicTagList';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const useGenderTabs = (disabled?: boolean) => {
    const t = useTranslations('playtech.mobile.system.registration.');
    const dTagGenderList = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.genderList,
        defaultValue: 'Mr, Mrs, Miss, Ms, Mx',
        withLowerCase: false
    });

    return useMemo(() => {
        return dTagGenderList.map((gender) => ({
            label: t(`gender.${gender.toLowerCase()}`),
            value: gender,
            disabled
        }));
    }, [dTagGenderList, disabled, t]);
};
